import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { CalendarClock, CheckCircle2, Radio, User } from 'lucide-react';
import { ROUTES } from '@/constants';
import { MATCH_STATUS } from '@/constants/matches';
import { cn } from '@/lib/utils';

const TABS = [
  { label: 'Upcoming', status: MATCH_STATUS.UPCOMING, icon: CalendarClock },
  { label: 'Live', status: MATCH_STATUS.LIVE, icon: Radio },
  { label: 'Completed', status: MATCH_STATUS.COMPLETED, icon: CheckCircle2 },
];

function ScorerBottomNav() {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const onMatches = location.pathname === ROUTES.MATCHES;
  const activeStatus = searchParams.get('status') || MATCH_STATUS.UPCOMING;
  const onProfile = location.pathname.startsWith(ROUTES.SETTINGS_PROFILE);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t border-border bg-card/95 pb-[env(safe-area-inset-bottom)] backdrop-blur-xl lg:hidden"
      aria-label="Scorer navigation"
    >
      <ul className="flex items-stretch justify-around">
        {TABS.map(({ label, status, icon: Icon }) => {
          const isActive = onMatches && activeStatus === status;
          return (
            <li key={status} className="flex-1">
              <Link
                to={`${ROUTES.MATCHES}?status=${status}`}
                aria-current={isActive ? 'page' : undefined}
                className={cn(
                  'flex min-h-[56px] flex-col items-center justify-center gap-0.5 px-1 py-2 text-[10px] font-semibold transition-colors',
                  isActive ? 'text-primary' : 'text-muted-foreground'
                )}
              >
                <Icon className="h-5 w-5" aria-hidden="true" />
                <span>{label}</span>
              </Link>
            </li>
          );
        })}
        <li className="flex-1">
          <Link
            to={ROUTES.SETTINGS_PROFILE}
            aria-current={onProfile ? 'page' : undefined}
            className={cn(
              'flex min-h-[56px] flex-col items-center justify-center gap-0.5 px-1 py-2 text-[10px] font-semibold transition-colors',
              onProfile ? 'text-primary' : 'text-muted-foreground'
            )}
          >
            <User className="h-5 w-5" aria-hidden="true" />
            <span>Profile</span>
          </Link>
        </li>
      </ul>
    </nav>
  );
}

export default ScorerBottomNav;
